<template>
  <div class="relative assignee-info flex items-center">
    <div
      v-for="(assignee, index) in topThreeAssignees"
      :key="assignee.id"
      class="thumbnail-wrapper"
      :style="{ left: `${index * 15}px`, zIndex: topThreeAssignees.length - index }"
    >
      <thumbnail
        :src="assignee.src"
        :variant="'circle'"
        :username="assignee.name"
        class="user-thumbnail"
        size="30px"
      />
    </div>
  </div>
</template>

<script>
import Thumbnail from '../../../../../components/widgets/Thumbnail.vue';
export default {
  components: {
    Thumbnail,
  },
  props: {
    assignees: {
      type: Array,
      required: true,
    },
  },
  computed: {
    topThreeAssignees() {
      return this.assignees.slice(0, 3);
    },
  },
  mounted() {
    console.log('Assignee', this.assignees);
  },
};
</script>

<style lang="scss" scoped>
.assignee-info {
  position: relative;
  height: 30px; /* Match the thumbnail size */
  right: 60px;
}

.thumbnail-wrapper {
  position: absolute;
  transition: transform 0.2s;
}

.user-thumbnail {
  border: 2px solid white; /* Optional: clean border separation */
  box-shadow: 0 0 0 1px #e0e0e0; /* Optional: subtle border effect */
  border-radius: 50%;
}
</style>